// Ported from the Polaris kit: src/components/ui/alert/index.js.
// Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs.
// Change the design in the kit first, then re-port.
import { cva } from 'class-variance-authority';

export { default as Alert } from './Alert.vue';
export { default as AlertDescription } from './AlertDescription.vue';
export { default as AlertTitle } from './AlertTitle.vue';

export const alertVariants = cva(
  'relative w-full rounded-polaris-lg border border-solid border-polaris-border px-4 py-3 type-polaris-body grid has-[>svg]:grid-cols-[1rem_1fr] grid-cols-[0_1fr] has-[>svg]:gap-x-3 gap-y-0.5 items-start [&>svg]:size-4 [&>svg]:translate-y-0.5 [&>svg]:text-current',
  {
    variants: {
      variant: {
        default: 'bg-polaris-card text-polaris-card-foreground',
        destructive:
          'text-polaris-destructive bg-polaris-card [&>svg]:text-current [&>[data-slot=alert-description]]:text-polaris-destructive/90',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  }
);
